import moment from 'moment'

/**
 * 本日より過去かどうか
 * @param {string} dateVal 日付（yyyy-mm-dd）
 * @returns {boolean}
 */
export function isBeforeToday(dateVal) {
  const today = moment().startOf('day')
  return moment(dateVal).isBefore(today)
}
